import { EChannels } from 'core/model/enums';
import { env } from 'shared/utils/env.utils';

export const IMAGES_ROUTES = env('VITE_API_URL_IMAGES_ROUTES');

export const CHANNEL_NAME_BY_CHANNEL_ID: Record<EChannels, string> = {
  [EChannels.DIA_DIA]: 'Diadía',
  [EChannels.INSUMA]: 'Insuma',
};
